export const getUserManagementState = (state) => state.userManagementState;

export const getUserManagementAvailableRoles = (state) => state.userManagementState.availableRoles;
